import type { ReactElement } from 'react';
import { SpinnerIcon } from 'common/components/SpinnerIcon';

type Props = { text?: string | null };

export function Spinner(props: Props): ReactElement {
  return (
    <div className="m-loader">
      <div className="m-loader-container">
        <div className="m-loader-spinner">
          <SpinnerIcon />
        </div>
        {props.text && <p>{props.text}</p>}
      </div>
    </div>
  );
}
